// Uživatelské menu v pravé části horní lišty — dropdown s Předvolbami a Odhlášením. Data (jméno,
// logout URL, canChangePassword) přicházejí z control desktopu přes `desktop/user-info`. Předvolby
// otevírají legacy form dle GlobalName (probublá `form/open`). Odhlásit vyčistí OBĚ session: Magic
// (navigací control iframu na External.Logout) i Phoenix (`signOut`), a vrátí na LoginGate.
// Help ikona je samostatně (viz DesktopHeaderControls).

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthActions } from '@/shared/auth';
import {
  sendMagicOpenForm,
  setPendingMenuOpen,
  useMagicControlBridge,
  useMagicDesktopStore,
} from '@/shared/legacyMagicBridge';
import { DropdownMenu, MenuItem } from '@/shared/ui/dropdown-menu';
import { Icon } from '@/shared/ui/icon';

const PREFERENCE_FORM = 'Menu.UserPreference';
const PASSWORD_FORM = 'Menu.UserPasswordEdit';

export function UserAccountMenu() {
  const { t } = useTranslation('common');
  const userInfo = useMagicDesktopStore((s) => s.userInfo);
  const { logoutMagic } = useMagicControlBridge();
  const { signOut } = useAuthActions();
  const [open, setOpen] = useState(false);

  const openForm = (form: string, title: string) => {
    // Předvolby/přístupové údaje otevíráme do plochy (replace) — bridge vyzvedne záměr při form/open.
    setPendingMenuOpen('replace', title);
    sendMagicOpenForm(form);
    setOpen(false);
  };

  const logout = async () => {
    setOpen(false);
    // 1) Vyčisti Magic session přes control iframe (External.Logout), počkej na načtení.
    if (userInfo?.logoutUrl) {
      try {
        await logoutMagic(userInfo.logoutUrl);
      } catch {
        // i tak pokračuj odhlášením z Phoenixu
      }
    }
    // 2) Vyčisti Phoenix session → AuthProvider přepne na `unauthenticated` → LoginGate.
    await signOut();
  };

  return (
    <DropdownMenu
      trigger={
        <button
          type="button"
          className="rounded-phx-sm text-phx-text-2 hover:bg-phx-surface-2 flex h-[24px] cursor-pointer items-center gap-1.5 border-0 bg-transparent px-1.5"
          title={userInfo?.userName ?? t('userMenu.account')}
          aria-label={t('userMenu.account')}
        >
          <Icon name="user" size={15} />
          {userInfo?.userName && (
            <span className="max-w-[160px] truncate text-[12px]">{userInfo.userName}</span>
          )}
        </button>
      }
      align="end"
      backdrop
      open={open}
      onOpenChange={setOpen}
      className="p-phx-1 w-[220px]"
    >
      <MenuItem icon="cog" onClick={() => openForm(PREFERENCE_FORM, t('userMenu.preferences'))}>
        {t('userMenu.preferences')}
      </MenuItem>
      {userInfo?.canChangePassword && (
        <MenuItem icon="lock" onClick={() => openForm(PASSWORD_FORM, t('userMenu.password'))}>
          {t('userMenu.password')}
        </MenuItem>
      )}
      <MenuItem icon="logout" tone="danger" onClick={() => void logout()}>
        {t('userMenu.logout')}
      </MenuItem>
    </DropdownMenu>
  );
}
